<template>
  <div v-if="cargando">
    <div class="row">
      <div class="col-md-12 text-center">
        <h3>
          Cargando
          <i class="fa fa-spin fa-spinner"></i>
        </h3>
      </div>
    </div>
  </div>
  <div v-else>
    <br />
    <b-container fluid>
      <b-row>
        <!-- <b-col md="2">
          <b-form-group horizontal label="Orden" class="mb-0">
            <b-input-group>
              <b-form-select v-model="orden" slot="append" @input="listInvoice">
                <option :value="'asc'">Más Antiguo</option>
                <option :value="'desc'">Más Reciente</option>
              </b-form-select>
            </b-input-group>
          </b-form-group>
        </b-col> -->
         <b-col cols="12" sm="12" md="4" lg="4" xl="4">
          <div style="background: #f8f9fa; padding: 10px; border-radius: 5px; border-left: 5px solid #007bff; display: flex; align-items: center;">
            <h5 style="margin: 0; display: inline-flex; align-items: center;">
              <strong>📅 Facturas de la semana </strong>
            </h5>
          </div>
        </b-col>
        <b-col cols="12" sm="12"	md="4"	lg="4"	xl="5">
          <b-form inline>
              Desde: <b-input type="date" v-model="f1"/>
              Hasta: <b-input type="date" v-model="f2"/>
          <b-tooltip target="info-icon" triggers="hover">
              Buscar Factura por rango de fecha ejemplo: Desde: 01/10/2024 Hasta: 20/10/2424
          </b-tooltip>
              <i id="info-icon" class="fas fa-question-circle text-primary" style="margin-left: 8px; cursor: pointer; font-size: 18px;"></i>
              <b-button size="sm" @click="listInvoice" variant="success" class="ml-2">Buscar</b-button>
          </b-form>
        </b-col>
        <b-col cols="12" sm="12"	md="4"	lg="4"	xl="3">
          <template>
              <DatePicker 
                style="color: #20a8d8; border: 3px solid #20a8d8; border-radius: 8px;" 
                placeholder="Buscar Factura por día 📅"
                v-model="buscarxdia" 
                lang="es" 
                :disabled-date="deshabilitarFechasFuturas" 
                @input="actualizarFecha(buscarxdia)"/>
          </template>
        </b-col>
        <!-- <b-col md="2">
          <b-form-group horizontal label="Mostrar" class="mb-0">
            <b-input-group>
              <b-form-select v-model="limite" slot="append" @input="listInvoice">
                <option :value="10">10</option>
                <option :value="25">25</option>
                <option :value="50">50</option>
                <option :value="100">100</option>
              </b-form-select>
            </b-input-group>
          </b-form-group>
        </b-col> -->
      </b-row>
      <b-row>
        <b-col cols="12" sm="12"	md="12"	lg="4"	xl="2">
          <div class="mt-3">
            <b-button size="sm" variant="primary" @click="listInvoice">
              Actualizar Tabla <i class="fa fa-sync-alt"></i>
            </b-button>
          </div>
        </b-col>
        <b-col cols="12" sm="12"	md="12"	lg="4"	xl="8"></b-col>
        <b-col cols="12" sm="12"	md="12"	lg="4"	xl="2">
          <div class="mt-3">
            <b-button class="float-right" size="sm" variant="warning" @click="clearFechas()">
              Limpiar filtros <i class="fas fa-broom"></i> <!-- Escoba -->
            </b-button>
          </div>
        </b-col>
      </b-row>
      <br />
      <b-table
        responsive
        small
        striped
        :outlined="outlined"
        :items="invoices"
        :fields="invoices_fields"
        :current-page="pactual"
        :per-page="limite"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
      >
        <template slot="acredito" slot-scope="row">
          <template v-if="row.item && row.item.pagado == 0">
            <i title="Factura a crédito por pagar" class="fa fa-copyright text-danger"></i>
          </template>
          <template v-else-if="row.item && row.item.pagado == 1">
            <i title="Factura a crédito pagada" class="fa fa-copyright text-success"></i>
          </template>
        </template>
        <template slot="estado" slot-scope="row">
          <div class="text-center">
            <template v-if="row.item.emitido==1 && row.item.baja==1">
              <div>
                <span class="badge badge-dark">
                  Baja
                  <i class="fa fa-ban"></i>
                </span>
              </div>
            </template>
            <template v-else-if="row.item.emitido==3 && row.item.baja==0">
              <div>
                <span class="badge badge-info">
                  Baja pendiente
                  <i class="fa fa-ban"></i>
                </span>
              </div>
            </template>
            <template v-else>
              <div v-if="row.item.emitido==1">
                <span class="badge badge-success">
                  Emitido
                  <i class="fa fa-check"></i>
                </span>
              </div>
              <div v-else-if="row.item.emitido==0">
                <span class="badge badge-warning">
                  Procesando
                  <i class="fa fa-spin fa-spinner"></i>
                </span>
              </div>
              <div v-else-if="row.item.emitido==2">
                <span class="badge badge-danger">
                  Rechazado
                  <i class="fa fa-times"></i>
                </span>
              </div>
              <div v-else-if="row.item.emitido==6">
                <span class="badge badge-info">
                  Procesando OSE
                  <i class="fa fa-times"></i>
                </span>
              </div>
            </template>
          </div>
        </template>
        <template slot="receptor" slot-scope="row">
          <template
            v-if="row.item.idReceptor.length == 11"
          >{{row.item.idReceptor}} - {{row.item.receiver.razonSocial}}</template>
          <template
            v-else-if="row.item.receiver.tipo == 0"
          >{{row.item.idReceptor}} - {{row.item.receiver.razonSocial}}</template>
        </template>
        <template slot="emisor" slot-scope="row">
                <template v-if="row.item && row.item.adicional && row.item.adicional !=''">
                    {{row.item.adicional.username}}
                </template>   
        </template>
        <template
          slot="emision"
          slot-scope="row"
        >{{ row.item.fechaEmision | moment('D/M/Y hh:mm:ss A') }}</template>
        <template slot="moneda" slot-scope="row">
          <div class="text-right">
            <template v-if="row.item.tipoMoneda=='PEN'">S/</template>
            <template v-else-if="row.item.tipoMoneda=='USD'">$</template>
            <template v-else>{{ row.item.tipoMoneda }}</template>
            {{row.item.importeTotal}}
          </div>
        </template>
        <template slot="acciones" slot-scope="row">
          <template v-if="row.item.emitido!=2 && row.item.baja!=1">
            <div class="d-none d-xl-block">
              <b-button-group>
                <template>
                  <b-button 
                    v-show="!row.item.loading"
                    variant="light"
                    size="sm"
                    @click="mostrarDetalles(row, row.index)"
                    title="Mas opciones"
                  >
                    <template v-if="!row.item.mostrardetalles">
                      <i class="fa fa-plus"></i>
                    </template>
                    <template v-else>
                      <i class="fa fa-minus"></i>
                    </template>
                  </b-button>
                </template>
                <b-button size="sm" v-show="row.item.loading" variant="ligth">
                  <i class="fa fa-spin fa-spinner"></i>
                </b-button>
                <b-button v-b-modal.prevmodal v-b-tooltip.hover @click="viewPdf(row.item)">
                  <i title="Vista Previa" class="fa fa-tv"></i>
                </b-button>
                <b-dropdown no-caret boundary="viewport">
                  <template v-slot:button-content>
                      <i class="fa fa-chevron-down"></i>
                  </template>
                  <b-dropdown-item @click="downloadPdf(row.item)">
                    <i class="fa fa-file-pdf mr-2 text-dark"></i> Descargar PDF
                  </b-dropdown-item>
                  <b-dropdown-item @click="downloadCdr(row.item)" :disabled="row.item.emitido==0">
                    <i class="fa fa-file-archive mr-2 text-dark"></i> Descargar CDR
                  </b-dropdown-item>
                  <b-dropdown-item @click="downloadXml(row.item)" :disabled="row.item.emitido==0">
                    <i class="fa fa-file-code mr-2 text-dark"></i> Descargar XML
                  </b-dropdown-item>
                  <b-dropdown-item @click="convertirAnticipo(row.item)">
                    <i class="far fa-file mr-2 text-dark"></i> Convertir Anticipo
                  </b-dropdown-item>
                  <b-dropdown-item @click="previoEnvioFactoring(row.item)">
                     <img src="/images/banco.png" height="22"/> Facturas Factoring
                  </b-dropdown-item>
                </b-dropdown>
                <b-button @click="setInvoice(row.item)" v-b-modal.sendfacturaemail1 v-b-tooltip.hover>
                  <i class="fa fa-share-alt" title="Compartir Documento" aria-hidden="true"></i>
                </b-button>
                <button @click="ticketEnvio(row.item)" type="button" class="btn btn-dark">
                  <i title="Ticket Envío" class="fa fa-ticket-alt text-white"></i>
                </button>
                <b-button
                  :disabled="row.item.credito==1"
                  v-b-tooltip.hover 
                  variant="primary"
                  @click="advertConvertCredit(row.item)"
                >
                  <i title="Convertir a crédito" class="fa fa-handshake text-white"></i>
                </b-button>
                <b-button
                  v-b-modal.noticeFactura
                  variant="success"
                  id="tooltipButton-12"
                  @click="catchItems(row.item,1)"
                >
                  <i title="Emisión Rapida Factura" class="fa fa-1x fa-copy"></i>
                </b-button>
                <b-button
                  v-b-modal.noticeGuia
                  variant="warning"
                  id="tooltipButton-13"
                  @click="catchItems(row.item,2)"
                >
                  <i title="Emisión Rapida Guia" class="fa fa-1x fa-truck"></i>
                </b-button>
                <b-button
                  v-if="row.item.emitido==0 || row.item.baja==1"
                  v-show="row.item.emitido!=3"
                  :disabled="true"
                  v-b-tooltip.hover
                  class="disabled btn btn-danger"
                >
                  <i title="Baja de Factura" class="fa fa-trash-alt text-white"></i>
                </b-button>
                <b-button
                  v-else
                  v-show="row.item.emitido!=3"
                  @click="preBaja(row.item)"
                  v-b-tooltip.hover
                  class="btn btn-danger"
                >
                  <i title="Baja de Factura" class="fa fa-trash-alt text-white"></i>
                </b-button>
              </b-button-group>
            </div>
            <div class="d-xl-none">
              <b-dropdown id="dropdown-1" class="m-md-2" variant="link" no-caret>
                <template v-slot:button-content>
                  <button class="btn btn-light">
                    <i class="fa fa-ellipsis-v"></i>
                  </button>
                </template>
                <b-dropdown-item @click="viewPdf(row.item)">
                  <i class="fa fa-tv mr-2 text-dark"></i> Vista Previa
                </b-dropdown-item>
                <b-dropdown-item @click="downloadPdf(row.item)">
                  <i class="fa fa-file-pdf mr-2 text-dark"></i> Descargar PDF
                </b-dropdown-item>
                <b-dropdown-item @click="setInvoice(row.item)">
                  <i class="fa fa-envelope mr-2 text-dark"></i> Enviar por Mail
                </b-dropdown-item>
                <b-dropdown-item @click="downloadCdr(row.item)">
                  <i class="fa fa-file-archive mr-2 text-dark"></i> Descargar CDR
                </b-dropdown-item>
                <b-dropdown-item @click="downloadXml(row.item)">
                  <i class="fa fa-file-code mr-2 text-dark"></i> Descargar XML
                </b-dropdown-item>
                <b-dropdown-item
                  :disabled="row.item.credito==1"
                  @click="advertConvertCredit(row.item)"
                >
                  <i class="fa fa-handshake text-white mr-2 text-primary"></i> Convertir a crédito
                </b-dropdown-item>
                <b-dropdown-item @click="catchItems(row.item,1)">
                  <i class="fa fa-1x fa-copy mr-2 text-success"></i> Emisión Rapida Factura
                </b-dropdown-item>
                <b-dropdown-item @click="catchItems(row.item,2)">
                  <i class="fa fa-1x fa-truck mr-2 text-warning"></i> Emisión Rapida Guia
                </b-dropdown-item>
                <b-dropdown-item
                  class="text-muted disabled"
                  :disabled="true"
                  v-if="row.item.emitido==0 || row.item.baja==1"
                >
                  <i class="fa fa-trash-alt mr-2 text-danger"></i> Baja de Factura
                </b-dropdown-item>
                <b-dropdown-item v-else @click="preBaja(row.item)">
                  <i class="fa fa-trash-alt mr-2 text-danger"></i> Baja de Factura
                </b-dropdown-item>
              </b-dropdown>
            </div>
            <factura-rapida-items :item="separarArray" :action="action" @totalitems="totalitems"></factura-rapida-items>
          </template>
          <template v-else-if="row.item.emitido==6">
            <b-button-group>
              <b-button v-b-modal.prevmodal v-b-tooltip.hover @click="viewPdf(row.item)">
                <i title="Vista Previa" class="fa fa-television"></i>
              </b-button>
              <b-button
                v-if="row.item.emitido==6"
                @click="estadoEmision(row.item, 1)"
                v-b-modal.motivorechazo1
                v-b-tooltip.hover
                class="btn"
                variant="info"
              >
                <i title="Checkear alta OSE" class="fa fa-eye text-white"></i>
              </b-button>
            </b-button-group>
          </template>
          <template v-else>
            <b-button-group>
              <template>
                  <b-button
                    v-if="row.item.emitido==2"
                    v-show="!row.item.loading"
                    variant="light"
                    size="sm"
                    @click="mostrarDetalles(row, row.index)"
                    title="Mas opciones"
                  >
                    <template v-if="!row.item.mostrardetalles">
                      <i class="fa fa-plus"></i>
                    </template>
                    <template v-else>
                      <i class="fa fa-minus"></i>
                    </template>
                  </b-button>
                </template>
              <b-button @click="downloadCdr(row.item)">
                <i title="Descargar CDR" class="fa fa-file-archive"></i>
              </b-button>
              <b-button
                v-if="row.item.emitido==2"
                @click="estadoEmision(row.item, 2)"
                v-b-modal.motivorechazo1
                v-b-tooltip.hover
                class="btn"
                variant="primary"
              >
                <i title="Estado de la emision" class="fa fa-eye text-white"></i>
              </b-button>
              <b-button
                  v-if="row.item.emitido==2"
                  v-b-modal.noticeFactura
                  variant="success"
                  id="tooltipButton-12"
                  @click="catchItems(row.item,1)">
                  <i title="Emisión Rapida Factura" class="fa fa-1x fa-copy"></i>
              </b-button>
            </b-button-group>
          </template>
        </template>
        <template slot="row-details" slot-scope="row">
          <!-- {{ getMoneda(row.item.tipoMoneda) }} -->
          <b-card class="tamanioletra">
            <b-table striped hover :items="row.item.lista" :fields="listaitems_fields">
              <template slot="index" slot-scope="row">{{ row.index+1 }}</template>
              <template slot="cantidad" slot-scope="row">
                <div>{{ Number.parseFloat(row.item.cantidad).toFixed(2) }}</div>
              </template>
              <template slot="baseAfectacionIgv" slot-scope="row">
                <div>
                  <template v-if="row.item.moneda=='PEN'">S/</template>
                  <template v-else-if="row.item.moneda=='USD'">$</template>
                  <template v-else>{{ row.item.moneda }}</template>
                  <template
                    v-if="row.item.precioVentaUnitario"
                  >{{ Number.parseFloat(row.item.baseAfectacionIgv).toFixed(2) }}</template>
                </div>
              </template>
              <template slot="montoAfectacionIgv" slot-scope="row">
                <div>
                  <template v-if="row.item.moneda=='PEN'">S/</template>
                  <template v-else-if="row.item.moneda=='USD'">$</template>
                  <template v-else>{{ row.item.moneda }}</template>
                  <template
                    v-if="row.item.precioVentaUnitario"
                  >{{ Number.parseFloat(row.item.montoAfectacionIgv).toFixed(2) }}</template>
                </div>
              </template>
              <template slot="descuento" slot-scope="row">
                <div>
                  <template v-if="row.item.moneda=='PEN'">S/</template>
                  <template v-else-if="row.item.moneda=='USD'">$</template>
                  <template v-else>{{ row.item.moneda }}</template>
                  <template v-if="row.item.descuento">
                    {{ Number.parseFloat(row.item.descuento).toFixed(2) }}
                  </template>
                </div>
              </template>
              <template slot="valorVenta" slot-scope="row">
                <div>
                  <template v-if="row.item.moneda=='PEN'">S/</template>
                  <template v-else-if="row.item.moneda=='USD'">$</template>
                  <template v-else>{{ row.item.moneda }}</template>
                  <template v-if="row.item.tipoAfectacionIgv=='10'">            
                      {{ Number.parseFloat(row.item.valorVenta*(row.item.porcentajeImpuesto == '18.00000' ? 1.18 : 1.105)).toFixed(2) }}
                     <div style="float:right;color:red">
                        {{row.item.porcentajeImpuesto == '18.00000' ? '18%' : '10.5%'}}
                     </div>
                      
                  </template>
                  <template v-else-if="row.item.tipoAfectacionIgv=='20' || row.item.tipoAfectacionIgv=='30'">
                      {{ Number.parseFloat(row.item.valorVenta).toFixed(2) }}
                  </template>
                </div>
              </template>
            </b-table>
          </b-card>
        </template>
      </b-table>
    </b-container>
    <b-modal id="sendfacturaemail1" title="Compartir Documento" v-model="previacorreo">
      <div style="background-color: #e7ffcd" class="p-2" role="group">
        <label for="inputLive">Enviar por WhatsApp:
          <svg xmlns="http://www.w3.org/2000/svg" height="22" width="20" viewBox="0 0 448 512">
          <path fill="#0dc143" d="M92.1 254.6c0 24.9 7 49.2 20.2 70.1l3.1 5-13.3 48.6L152 365.2l4.8 2.9c20.2 12 43.4 18.4 67.1 18.4h.1c72.6 0 133.3-59.1 133.3-131.8c0-35.2-15.2-68.3-40.1-93.2c-25-25-58-38.7-93.2-38.7c-72.7 0-131.8 59.1-131.9 131.8zM274.8 330c-12.6 1.9-22.4 .9-47.5-9.9c-36.8-15.9-61.8-51.5-66.9-58.7c-.4-.6-.7-.9-.8-1.1c-2-2.6-16.2-21.5-16.2-41c0-18.4 9-27.9 13.2-32.3c.3-.3 .5-.5 .7-.8c3.6-4 7.9-5 10.6-5c2.6 0 5.3 0 7.6 .1c.3 0 .5 0 .8 0c2.3 0 5.2 0 8.1 6.8c1.2 2.9 3 7.3 4.9 11.8c3.3 8 6.7 16.3 7.3 17.6c1 2 1.7 4.3 .3 6.9c-3.4 6.8-6.9 10.4-9.3 13c-3.1 3.2-4.5 4.7-2.3 8.6c15.3 26.3 30.6 35.4 53.9 47.1c4 2 6.3 1.7 8.6-1c2.3-2.6 9.9-11.6 12.5-15.5c2.6-4 5.3-3.3 8.9-2s23.1 10.9 27.1 12.9c.8 .4 1.5 .7 2.1 1c2.8 1.4 4.7 2.3 5.5 3.6c.9 1.9 .9 9.9-2.4 19.1c-3.3 9.3-19.1 17.7-26.7 18.8zM448 96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96zM148.1 393.9L64 416l22.5-82.2c-13.9-24-21.2-51.3-21.2-79.3C65.4 167.1 136.5 96 223.9 96c42.4 0 82.2 16.5 112.2 46.5c29.9 30 47.9 69.8 47.9 112.2c0 87.4-72.7 158.5-160.1 158.5c-26.6 0-52.7-6.7-75.8-19.3z"/></svg>
        </label>
        <b-form-input type="number" style="border-color:black"  v-model="numeroWhatsApp" @keyup.enter="send_message(invoice)"></b-form-input>
        <b-form-text
          style="font-size: small !important; color: #ea0909 !important"
        >Ingrese su número de celular (9 dígitos)
        </b-form-text>
        <b-row>
          <b-col cols="9"></b-col>
          <b-col>
              <b-btn
                  :disabled="numeroWhatsApp.length < 9 || numeroWhatsApp.length > 9 "
                  size="sm"
                  variant="success"
                  @click="send_message(invoice)"
                >Enviar
              </b-btn>
          </b-col>
        </b-row>
      </div>
      <div style="background-color: #cce6ff" class="p-2" role="group">
        <label for="inputLive">Enviar por Correo: <i class="fa fa-envelope fa-lg" aria-hidden="true"></i></label> 
        <b-form-input style="border-color:black" v-model="recipients" type="email" @keyup.enter="sendMail(invoice)"></b-form-input>
        <b-form-text 
          style="font-size: small !important; color: #ea0909 !important"
        >Ingresa un correo ó varios separados por comas (,)</b-form-text>
      
        <b-row>
          <b-col cols="9"></b-col>
          <b-col>
            <b-btn
              v-if="!sendcorreo"
              size="sm"
              variant="primary"
              @click="sendMail(invoice)"
            >Enviar
            </b-btn>
            <b-btn v-else size="sm" class="float-right" variant="secondary">
              <i class="fa fa-spin fa-spinner"></i> Enviando...
            </b-btn>
          </b-col>
        </b-row>
      <hr class="mt-3">
        <h5>Correos en módulo Negocios:</h5>
        <h5><li style="list-style:none" class="mr-1" variant="dark" v-for="(item,index) in reciveEmail" :key="index">
        <b-badge pill variant="light">{{item}}
        <i @click="borrarCorreo(index)" class=" fa fa-times-circle text-dark cursor"></i></b-badge> 
        </li>
        </h5>
        <b-row>
          <b-col cols="9"></b-col>
          <b-col>
            <b-button v-if="recipients!=''" :disabled="mostraremail" size="sm" @click="enviarEmail(invoice)" variant="primary">Enviar a todos</b-button>
            <b-button v-else  :disabled="mostraremail" size="sm" @click="enviarEmail(invoice)" variant="primary">Enviar</b-button>
          </b-col>
        </b-row>
        <div slot="modal-footer"></div>
        </div>
    </b-modal>
    <b-modal id="motivorechazo1" title="Motivo del Rechazo" v-model="motivoRechazo">
      <div role="group">
        <div v-if="spinoff">
          <div class="row">
            <div class="col-md-12 text-center">
              <h3>
                Cargando
                <i class="fa fa-spin fa-spinner"></i>
              </h3>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="row">
            <div class="col-md-12 text-center">
              <h6>{{ descripcionRechazo }}</h6>
            </div>
          </div>
        </div>
      </div>
      <div slot="modal-footer" class="w-100">
        <b-btn
          v-if="!sendcorreo"
          size="sm"
          class="float-right"
          variant="primary"
          @click="motivoRechazo=!motivoRechazo"
        >Ok</b-btn>
      </div>
    </b-modal>
    <b-modal
      size="lg"
      title="Ticket Envío"
      v-model="ticketenvio">
      <template>
        <div>
          <ticket 
          :impresion="datosTicket" 
          :printweb="printweb"
          @update:printweb="printweb = $event" >
        </ticket>
        </div>
      </template>
      <div slot="modal-footer" class="w-100">
        <b-row>
          <b-col cols="4"></b-col>
          <b-col cols="2">
            <b-button size="sm" class="btn btn-info"  @click="printweb = true"><i class="fas fa-print"></i> Imprimir</b-button>
          </b-col>
          <b-col cols="2">
            <b-button size="sm" class="btn btn-danger" @click="printClose()"> Cerrar</b-button>
          </b-col>
          <b-col cols="4"></b-col>
        </b-row> 
      </div>
    </b-modal>
    <!-- <b-modal
      id="noticeGuia"
      size="lg"
      title="Informativo Telemovil"
      cancel-title="Cerrar"
      v-model="noticeEmisionGuia"
    >
      <b-row>
        <b-col cols="7">
          <img src="images/informativo.png" alt="Logo" />
        </b-col>
        <b-col cols="5">
          <br />
          <br />
          <br />
          <br />
          <br />
          <p
            class="noticeGuia"
          >Ud. va a emitir una GUIA DE REMISION a partir de la Factura seleccionada.</p>
          <em>
            <strong>Nota: A excepcion de los items por servicios</strong>
          </em>
        </b-col>
      </b-row>
      <div slot="modal-footer" class="w-100">
        <b-btn size="lg" class="float-right" variant="primary" @click="catchItems(2)">Continuar</b-btn>
        <b-btn
          size="lg"
          class="float-right noticeSalir"
          variant="danger"
          @click="closenotice()"
        >Salir</b-btn>
      </div>
    </b-modal> -->
    <b-modal
      id="prevmodal"
      size="lg"
      title="Vista Previa"
      cancel-title="Cerrar"
      v-model="previewmodal"
    >
      <template v-if="cargandopdf2">
        <div class="text-center">
          <h3>
            <i class="fa fa-spin fa-spinner"></i>
          </h3>Cargando vista previa
        </div>
      </template>
      <template v-else>
        <template v-if="pdfobject !==''">
          <b-embed :src="'data:application/pdf;base64,'+ pdfobject" allowfullscreen></b-embed>
        </template>
      </template>
    </b-modal>
    <div class="row">
      <div class="col-md-6">
        <p>Mostrando del {{desde}} al {{hasta}} de un total de {{total}} registros</p>
      </div>
      <div class="col-md-6">
        <div class="float-right">
          <b-pagination
            size="sm"
            :total-rows="total"
            v-model="currentPage"
            @input="listInvoice"
            :per-page="limite"
          ></b-pagination>
        </div>
      </div>
    </div>
    <vue-snotify></vue-snotify>
    <b-modal id="modal-center" centered v-model="modalFactoring">
      <template slot="modal-title">
        <b-row style="width:140%">
          <b-col cols="6">
            Documento: {{globalFactoringDatos.serie}} - {{globalFactoringDatos.numero}}
          </b-col>
          <b-col cols="6">
            Importe: {{globalFactoringDatos.importeTotal}}
          </b-col>
        </b-row>
      </template>
      <p class="text-justify">
        ESTIMADO CLIENTE:
        El sistema Fáctoring es un mecanismo financiero que le permitirá a Usted negociar sus facturas a crédito y disponer del efectivo yá mismo y con la más baja comisión % del mercado. 
      </p>  
      <p class="text-justify">
        La empresa GLOBAL FACTORING <b-link href="https://www.globalfactoring.com.pe/">www.globalfactoring.com.pe</b-link> (01)6158330 es una empresa internacional líder en este servicio financiero
        y al precionar el botón SI ENVIAR Usted presentará su solicitud y ellos se estarán contactando con Usted para concretar la operación.
      </p>
      <p class="text-justify">
        Una vez concretado la operación Usted podrá disponer del efectivo y ellos se encargarán de realizar la cobranza al su cliente.
      </p>
      <div slot="modal-footer">
        <b-btn
          size="lg" 
          class="float-right" 
          variant="primary" 
          @click="globalFactoring(globalDatosItem)">
          Si Enviar
        </b-btn>
        <b-btn
          style="margin-right:250px"
          size="lg"
          class="float-left"
          variant="danger"
          @click="cerrarModalFactoring()"
          >No Enviar
        </b-btn>
      </div>
    </b-modal>
    <b-modal id="modal-center" centered v-model="modalDeConfirmacion">
      <p>PODRA VISUALIZAR LA INFORMACION ENVIADA EN LA PESTAÑA REPORTES</p>
      <div slot="modal-footer">
        <b-btn
          size="lg" 
          class="float-right" 
          variant="primary" 
          @click="cerrarModalConfirmacion()">
          OK
        </b-btn>
      </div>
    </b-modal>
    <b-modal id="modalpreproccess" v-model="modal">
      <template slot="modal-title">
        <i class="fa fa-exclamation-triangle text-danger"></i> Dar de baja a una Factura
      </template>
      <p class="my-4 h4">
        <b>{{this.$store.getters.userData.username}}</b>, realmente desea dar de baja a la siguiente factura?
      </p>
      <b-list-group>
        <template>
          <template>
            <b-list-group-item>{{facturaItemBaja.serie + '-' + facturaItemBaja.numero + ' | ' + facturaItemBaja.idReceptor + '-' + facturaItemBaja.razonSocial}}</b-list-group-item>
          </template>
        </template>
      </b-list-group>
      <br />
      <b-alert
        v-if="!loading2"
        variant="danger"
        show
      >El siguiente procedimiento no se puede deshacer.</b-alert>
      <b-alert v-else variant="danger" show>Estamos dando de baja los documentos indicados.</b-alert>
      <template slot="modal-footer">
        <template v-if="!loading2">
          <b-button variant="secondary" @click="modal=false">No</b-button>
          <b-button variant="danger" @click="sendBaja">
            <i class="fa fa-cog"></i> Procesar
          </b-button>
        </template>
        <b-button v-else disabled variant="danger">
          <i class="fa fa-spin fa-cog"></i> Procesando
        </b-button>
      </template>
    </b-modal>
    <b-modal 
      size="lg" 
      id="modalsunat" 
      v-model="modalsunat"
      title="Mensaje del portal de SUNAT"
      >
      <template v-if="loadingestadocpe">
        <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong> Cargando...</strong>
        </div>
      </template>
      <template v-else>
        <template v-if="respuestasunat=='1'">
          <table border width="100%">
            <tr>
              <td style="background: #3399cd; text-align: center;">
                <span style="font-size: 18px; font-weight: bold;">Consulta Validez del Comprobante de Pago Electrónico</span>
              </td>
            </tr>
          </table><br>
          <table border width="100%">
            <tr>
              <td style="background: #b6cbeb">
                <b>Resultado de la consulta</b>
              </td>
            </tr>
            <tr>
              <td>
                <b>La Factura Electrónica {{ comprobante.serie }}-{{ comprobante.numero }} es un comprobante de pago válido</b>
              </td>
            </tr>
          </table>
        </template>
        <template v-if="respuestasunat=='0'">
          <table border width="100%">
            <tr>
              <td style="background: #3399cd; text-align: center;">
                <span style="font-size: 18px; font-weight: bold;">Consulta Validez del Comprobante de Pago Electrónico.</span>
              </td>
            </tr>
          </table><br>
          <table border width="100%">
            <tr>
              <td style="background: #b6cbeb">
                <b>Resultado de la consulta</b>
              </td>
            </tr>
            <tr>
              <td>
                <b>La Factura Electrónica {{ comprobante.serie }}-{{ comprobante.numero }} no existe en los registros de SUNAT.</b>
              </td>
            </tr>
          </table>
        </template>
      </template>
      <template slot="modal-footer">
          <b-button size="sm" @click="closeCpe()" variant="danger"> Cerrar</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import "vue2-datepicker/locale/es";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import axios from "axios";
import download from "downloadjs";
import FacturaRapidaItems from '@/components/comunes/FacturaRapidaItems'
import { Departamentos } from '@/shared/utils'
import { PulseLoader } from 'vue-spinner/dist/vue-spinner.min.js'
import Ticket from '@/components/comunes/Ticket'
export default {
  name: "FacturaConsulta",
  components:{
    FacturaRapidaItems,
    DatePicker,
    PulseLoader,
    Ticket,
  },
  props: ["reload", "reloadInvoice"],
  data: () => {
    return {
      loadingestadocpe: false,
      modalsunat: false,
      respuestasunat: '',
      motivoRechazo: false,
      spinoff: false,
      descripcionRechazo: "",
      facturaItemBaja: {
        serie: "",
        numero: "",
        idReceptor: "",
        razonSocial: ""
      },
      facturaBaja: {
        descripcion: "DE BAJA",
        serie: "",
        numero: "",
        tipoComprobante: "01"
      },
      itembaja: [],
      date: "",
      loading2: false,
      modal: false,
      bufferData: {},
      noticeEmisionFactura: false,
      noticeEmisionGuia: false,
      previewmodal: false,
      reloadLocal: {
        reload: false,
        preview: ""
      },
      outlined: true,
      previacorreo: false,
      sendcorreo: false,
      cargando: false,
      orden: "desc",
      limite: 100,
      invoices: [],
      itemsContainers: [],
      itemsContainersPadre: [],
      pdfobject: "",
      recipients: "",
      pactual: 1,
      total: 0.0,
      desde: 0.0,
      hasta: 0.0,
      filter: null,
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      currentPage: 1,
      totalRows: null,
      invoices_fields: [
        { key: "acredito", label: "" },
        { key: "serie", label: "Serie", sorteable: true },
        { key: "numero", label: "Numero", sorteable: true },
        { key: "emision", label: "Emisión", sorteable: true },
        { key: "receptor", label: "Receptor", sorteable: true },
        {key:  'emisor', label: 'Usuario', sortable: true},
        { key: "moneda", label: "Total Gravado", sorteable: true },
        { key: "estado", label: "Estado", sorteable: true },
        { key: "acciones", label: "Acciones" }
      ],
      listaitems_fields: [
        { key: "index" },
        { key: "codigoProducto", label: "Codigo", sorteable: true },
        { key: "unidadMedidaCantidad", label: "Unidad", sorteable: true },
        { key: "descripcion", label: "Descripción", sorteable: true },
        { key: "cantidad", label: "Cantidad", sorteable: true },
        { key: "baseAfectacionIgv", label: "Valor Total", sorteable: true },
        { key: "montoAfectacionIgv", label: "IGV", sorteable: true },
        { key: "descuento", label: "Descuento", sorteable: true },
        { key: "valorVenta", label: "Precio Total", sorteable: true }
      ],
      cargandopdf: false,
      cargandopdf2: false,
      itemsdetalles: [],
      comprobante: {},
      separarArray:[],
      action: {
          i: false,
          reset: false
      },
      itemsCovert:[],
      valorFac:'',
      currentPageTerceros:1,
      ordenTerceros:'desc',
      customers:[],
      reciveEmail:[],
      mostraremail: true,
      // f1:'2025-10-01',
      // f2:'2025-11-07',
      f1:'',
      f2:'',
      fechaHoy:'',
      modalFactoring:false,
      globalFactoringDatos:{
        serie:'',
        numero:'',
        importeTotal:''
      },
      globalDatosItem:{},
      modalDeConfirmacion:false,
      numeroWhatsApp:'', 
      buscarxdia:'',
      fechaFacturaDelDia:'',
      ticketenvio:false,
      datosTicket:'',
      user: {
        username: "",
        rol: "",
        idEmisor: "",
        cuenta: {
          razonSocial: "",
          direccion: {}
        }
      },
      departamentoSeleccionado:'00',
      listDepartamento: Departamentos,
      listProvinceOrigen: [],
      provOrigenCargando: false,
      provOrigen: false,

      provinciaSeleccionada: '',
      distOrigenCargando:  false,
      distOrigen: false,
      distritoSeleccionado: '',
      listDistrictOrigen: [],

    obsTicket:'',
    numCelTicket:'',
    printweb: false,
    capturaProvinciaSeleccionada:'',
    capturaDepartamentoSeleccionado:'',
    };
  },
  mounted() {
    this.listInvoice();
    this.initIgv();
    this.listTerceros();
  },
  watch: {
    "reloadInvoice.reload": function() {
      this.reloadLocal.reload = this.reloadInvoice.reload;
      this.reloadLocal.preview = this.reloadInvoice.preview;
      if (this.reloadLocal.reload) {
        this.listInvoice();
      }
    },
    separarArray:function(){
      if(this.separarArray.length > 0){
        this.action.i = true  
      }
    },
    departamentoSeleccionado: function () {
        this.provOrigen = true,
        this.searchProvinceOrigen(1)
    },
    provinciaSeleccionada: function () {
        this.distOrigen = true,
        this.distOrigenCargando = true,
        this.searchDistrictOrigen(this.distOrigenCargando, 1)
    },
    distritoSeleccionado: function () {
        this.distOrigenCargando = false
 
    },
  },
  methods: {
    totalitems(value){
        this.itemsCovert = value
        this.action.i = false
        this.valorFac
        this.selectorQuickEmision(this.valorFac, this.itemsCovert)
    },
    closeCpe: function () {
      this.modalsunat = false
    },
    // queryCpe: function (item) {
    //   this.comprobante.serie = item.serie
    //   this.comprobante.numero = item.numero
    //   this.loadingestadocpe = true
    //   this.modalsunat = true
    //   axios
    //     .post(process.env.VUE_APP_API_URL + "sunat/cpe", {
    //       token: this.$store.getters.userToken,
    //       documento_id: item.idFactura,
    //       documento_tipo: '01'
    //     })
    //     .then(response => (
    //       this.respuestasunat = response.data.msg.data.estadoCp,
    //       this.loadingestadocpe = false
    //     ))
    //     .catch(error => (
    //       this.loadingestadocpe = false
    //     ))
    // },
    previoEnvioFactoring(item){
      this.modalFactoring = true;
      this.globalFactoringDatos.serie = item.serie;
      this.globalFactoringDatos.numero = item.numero;
      this.globalFactoringDatos.importeTotal = item.importeTotal;
      this.globalDatosItem = item;
    },
    cerrarModalFactoring(){
      this.modalFactoring = false;
    },
    globalFactoring(item){
      axios
        .post(process.env.VUE_APP_API_URL + "globalfactoring/enviar", {
          token: this.$store.getters.userToken,
          idDocumento: item.idFactura,
          tipoDocumento: '01'
        })
        .then(response => (
          this.modalFactoring = false,
          this.modalDeConfirmacion = true,
          this.$snotify.success(response.data.msg, "Exito")
        ))
        .catch(error => (
          console.log(error.data)
        ))
    },
    cerrarModalConfirmacion(){
      this.modalDeConfirmacion = false
    },
    mostrarDetalles: function(row, index) {
      if (row.detailsShowing) {
        row.toggleDetails();
        this.invoices[index].mostrardetalles = false;
      } else {
        this.invoices[index].mostrardetalles = true;
        this.invoices[index].loading = true;
        if (this.invoices[index].lista.length == 0) {
          setTimeout(() => this.detallesDocumento(row, index), 10);
        } else {
          this.invoices[index].loading = false;
          row.toggleDetails();
        }
      }
    },
    detallesDocumento: function(row, index) {
      axios
        .post(process.env.VUE_APP_API_URL + "facturas/items", {
          token: this.$store.getters.userToken,
          idfac: row.item.idFactura
        })
        .then(response =>
          this.parseDetallesDocumento(response.data.response, row, index)
        )
        .catch(error => (this.invoices[index].mostrardetalles = false));
    },
    parseDetallesDocumento: function(value, row, index) {
      this.invoices[index].lista = [];
      for (let i = 0; i < value.length; i++) {
        value[i].moneda = row.item.tipoMoneda;
        this.invoices[index].lista.push(value[i]);
      }
      this.invoices[index].loading = false;
      // this.invoices[index].mostrardetalles = false
      if (value.length > 0) {
        row.toggleDetails();
      }
    },
    advertConvertCredit: function(data) {
      this.$swal({
        title: "Convertir a Credito",
        text:
          "Seguro que desea convertir a credito la factura " +
          data.serie +
          "-" +
          data.numero,
        icon: "warning",
        buttons: true,
        dangerMode: true
      }).then(willDelete => {
        if (willDelete) {
          (this.cargando = true), this.convertCredit(data);
        } else {
        }
      });
    },
    convertCredit: function(data) {
      axios
        .post(process.env.VUE_APP_API_URL + "documentoscredito/convertirdoc", {
          token: this.$store.getters.userToken,
          tipodocumento: "01",
          iddocumento: data.idFactura
        })
        .then(
          response => (
            this.$snotify.success(response.data.msg, "Exito"),
            this.listInvoice()
          )
        )
        .catch(error => this.$snotify.error(error.response.data.msg, "Error"));
    },
    closenotice: function() {
      this.noticeEmisionFactura = false;
      this.noticeEmisionGuia = false;
    },
    noticeEmisionQuickInvioce: function(data) {
      (this.noticeEmisionFactura = true), (this.bufferData = data);
    },
    noticeEmisionQuickGuide: function(data) {
      (this.noticeEmisionGuia = true), (this.bufferData = data);
    },
    catchItems: function(data,value) {
      this.bufferData = data
      // this.noticeEmisionFactura = false;
      this.noticeEmisionGuia = false;
      let tag = document.createElement("i");
      tag.classList.add("fa", "fa-spin", "fa-spinner");
      this.$swal({
        title: "Obteniendo Items",
        content: tag,
        icon: "info",
        buttons: false,
        dangerMode: false
      });
      axios
        .post(process.env.VUE_APP_API_URL + "facturas/obtener/detalles", {
          token: this.$store.getters.userToken,
          p: this.bufferData.serie + "-" + this.bufferData.numero,
          filtro: "name"
        })
        .then(
          response => (
            (this.itemsContainers = response.data.response),
            (this.itemsContainersPadre = response.data.response),
            this.separarArray= this.itemsContainers.details,
            this.valorFac = value
          )
        )
        .catch(error => {});
    },
    selectorQuickEmision: function(value, valorI) {
      if (value == 1) {
        this.emisionRapidaFactura(), this.$swal.close();
      } else if (value == 2) {
        this.emisionRapidaGuia(), this.$swal.close();
      }
    },
    emisionRapidaFactura: function() {
      this.$emit("itemsfactura", this.itemsCovert),
      this.$emit("itemsfacturaPadre", this.itemsContainersPadre),
      this.changeTab(0);
    },
    emisionRapidaGuia: function() {
      this.$store.commit("datosRemitente", this.bufferData),
      this.$store.commit("itemstransient", this.itemsContainers),
      this.$router.push("/emision/guia").catch(err => {});
    },
    setInvoice: function(data) {
      this.previacorreo = true;
      this.invoice = data;
      this.reciveEmail = []
      this.listTerceros();
      let valordata = data
      let pasandoCorreoTerceros = {}
      this.customers.forEach(function(element){
        if(valordata.receiver.idReceptor == element.documento){
          pasandoCorreoTerceros = element.emailEnvio
        }      
      })
      this.reciveEmail = pasandoCorreoTerceros;
      if(this.reciveEmail && this.reciveEmail.length > 0){
        this.mostraremail = false;
      }else{
        this.mostraremail = true;
      }
    },
    listTerceros: function() {
      axios
        .post(process.env.VUE_APP_API_URL + "terceros/listar/1", {
          token: this.$store.getters.userToken,
          page: this.currentPageTerceros,
          order: this.ordenTerceros
        })
        .then(response =>(
            this.customers = response.data
          ))
        .catch(error => (
          console.log(error)
        ))
    },
    initIgv: function() {
      if (this.especificacionIgv === "01") {
        this.Especificacion = this.EspecificacionIgv;
      } else if (this.especificacionIgv === "02") {
        this.Especificacion = this.EspecificacionIgv2;
      }
    },
    listInvoice: function() {
      let dia1;
      let dia2;
      if(this.fechaFacturaDelDia !=''){
        dia1 = this.$moment(this.fechaFacturaDelDia).format('YYYY-MM-DD 00:00:00')
        dia2 = this.$moment(this.fechaFacturaDelDia).format('YYYY-MM-DD 23:59:59')  
      }else if(this.f1 !="" && this.f2 !=""){
        dia1 = this.$moment(this.f1).format('YYYY-MM-DD 00:00:00')
        dia2 = this.$moment(this.f2).format('YYYY-MM-DD 23:59:59')       
      }
      // this.fechaHoy = this.$moment().format('DD [de] MMMM [de] YYYY');
      this.cargando = true;
      let requestData = {
                token: this.$store.getters.userToken,
                page: this.currentPage,
                limit: this.limite,
                order: this.orden
            };
             // Agregar f1 y f2 solo si tienen valores
      if(dia1) {
        requestData.f1 = dia1;
      }if(dia2) {
        requestData.f2 = dia2;
      }
      axios
        .post(process.env.VUE_APP_API_URL + "facturas", requestData)
        .then(
          response => (
            (this.invoices = response.data.data),
            (this.totalRows = this.invoices.length),
            (this.total = response.data.total),
            (this.desde = response.data.from),
            (this.hasta = response.data.to),
            (this.cargando = false),
            this.invoices.forEach(function(element) {
              element.loading = false;
            }),
            this.cargarPreview()
          )
        )
        .catch(error => {});
    },
    cargarPreview: function() {
      if (this.reloadLocal.preview != "") {
        this.viewPdf(this.reloadLocal.preview);
        this.reloadLocal.preview = "";
      }
    },
    sendMail: function(data) {
      this.previacorreo = true;
      this.sendcorreo = true;
      axios
        .post(process.env.VUE_APP_API_URL + "facturas/mail", {
          token: this.$store.getters.userToken,
          id: data.idFactura,
          mail: this.recipients
        })
        .then(
          response => (
            (this.previacorreo = false),
            (this.sendcorreo = false),
            this.$snotify.success(response.data.msg, "Exito")
          )
        )
        .catch(
          error => (
            (this.previacorreo = false),
            (this.sendcorreo = false),
            this.$snotify.error(error.response.data.response, "Error")
          )
        );
    },
    downloadXml: function(data) {
      let xml = "";
      let file = "";
      let name = data.serie + "-" + data.numero + ".zip";
      let tag = document.createElement("i");
      this.cargandopdf = true;
      tag.classList.add("fa", "fa-spin", "fa-spinner");
      this.$swal({
        title: "Obteniendo XML",
        content: tag,
        icon: "info",
        buttons: false,
        dangerMode: false
      });
      axios
        .post(process.env.VUE_APP_API_URL + "facturas/xml", {
          token: this.$store.getters.userToken,
          id: data.idFactura
        })
        .then(
          response => (
            (xml = response.data.response.xml),
            (file = "data:application/zip;base64," + xml),
            this.downloadxml(file, name, xml),
            this.$swal.close()
          )
        )
        .catch(error =>
          this.$snotify.error("Error al descargar el archivo", "Error")
        );
    },
    downloadxml: function(file, name, xml) {
      if (xml != null) {
        download(file, name, "application/zip");
      } else {
        this.$snotify.error(
          "El documento aun no tiene constancia porque esta en proceso!",
          "Error"
        );
      }
    },
    viewPdf: function(data) {
      (this.previewmodal = true),
        (this.pdfobject = ""),
        (this.cargandopdf2 = true);
      axios
        .post(process.env.VUE_APP_API_URL + "facturas/pdf", {
          token: this.$store.getters.userToken,
          id: data.idFactura
        })
        .then(
          response => (
            (this.pdfobject = response.data.base64), (this.cargandopdf2 = false)
          )
        )
        .catch(error => {});
    },
    downloadPdf: function(data) {
      let tag = document.createElement("i");
      tag.classList.add("fa", "fa-spin", "fa-spinner");
      let name = data.serie + "-" + data.numero + ".pdf";
      let file = "data:application/pdf;base64," + data.pdf;
      this.cargandopdf = true;
      this.$swal({
        title: "Procesando Descarga",
        content: tag,
        icon: "info",
        buttons: false,
        dangerMode: false
      });
      axios
        .post(process.env.VUE_APP_API_URL + "facturas/pdf", {
          token: this.$store.getters.userToken,
          id: data.idFactura
        })
        .then(
          response => (
            (file = "data:application/zip;base64," + response.data.base64),
            (this.cargandopdf = false),
            download(file, name, "application/pdf"),
            this.$swal.close()
          )
        )
        .catch(error => {
          this.$swal.close(),
          this.$snotify.error(error.response.data.msg, 'Error')
        })
    },
    downloadCdr: function(data) {
      let tag = document.createElement("i");
      tag.classList.add("fa", "fa-spin", "fa-spinner");
      let name = "CDR-" + data.serie + "-" + data.numero + ".zip";
      let file = "data:application/pdf;base64," + data.pdf;
      this.cargandocdr = true;
      this.$swal({
        title: "Procesando Descarga",
        content: tag,
        icon: "info",
        buttons: false,
        dangerMode: false
      });
      axios
        .post(process.env.VUE_APP_API_URL + "facturas/constancia", {
          token: this.$store.getters.userToken,
          id: data.idFactura
        })
        .then(
          response => (
            (file = "data:application/zip;base64," + response.data.msg.xml),
            (this.cargandocdr = false),
            download(file, name, "application/zip"),
            this.$swal.close()
          )
        )
        .catch(error => (
          this.$swal.close(),
          this.$snotify.error(error.response.data.msg,'Error')
        ))
    },
    changeTab: function(value) {
      this.$emit("tabindex", value);
    },
    preBaja: function(value) {
      (this.modal = true),
        (this.itembaja = []),
        (this.facturaItemBaja.serie = value.serie),
        (this.facturaItemBaja.numero = value.numero),
        (this.facturaItemBaja.idReceptor = value.idReceptor),
        (this.facturaItemBaja.razonSocial = value.receiver.razonSocial),
        (this.facturaBaja.descripcion = "DE BAJA"),
        (this.facturaBaja.serie = value.serie),
        (this.facturaBaja.numero = value.numero),
        (this.facturaBaja.tipoComprobante = "01"),
        this.itembaja.push(this.facturaBaja),
        (this.date = value.fechaEmision);
    },
    sendBaja: function() {
      this.loading2 = true;
      axios
        .post(process.env.VUE_APP_API_URL + "comunicacionbaja/emitir", {
          token: this.$store.getters.userToken,
          fechaEmisionDocs: this.$moment(this.date).format("YYYY-MM-DD"),
          items: this.itembaja
        })
        .then(
          response => (
            (this.loading2 = false),
            (this.modal = false),
            this.listInvoice(),
            this.initValuesBaja(),
            this.$snotify.success(response.data.msg, "Éxito")
          )
        )
        .catch(
          error => (
            (this.loading2 = false),
            (this.modal = false),
            this.initValuesBaja(),
            this.$snotify.error(
              error.response.data.response.description,
              "Error"
            )
          )
        );
    },
    estadoEmision: function(value, tipo) {
      if (tipo === 1) {
        (this.descripcionRechazo = "Por favor verifique que tiene alta OSE"),
          (this.spinoff = false);
      } else if (tipo === 2) {
        this.spinoff = true;
        axios
          .post(process.env.VUE_APP_API_URL + "documento/motivorechazo", {
            token: this.$store.getters.userToken,
            serie: value.serie,
            numero: value.numero,
            tipo: "01"
          })
          .then(
            response => (
              (this.descripcionRechazo = response.data.msg.descripcion),
              (this.spinoff = false)
            )
          )
          .catch(
            error => (
              this.$snotify.error(error.response.data, "Error"),
              (this.motivoRechazo = false),
              (this.spinoff = false)
            )
          );
      }
    },
    initValuesBaja: function() {
      (this.facturaItemBaja.serie = ""),
        (this.facturaItemBaja.numero = ""),
        (this.facturaItemBaja.idReceptor = ""),
        (this.facturaItemBaja.razonSocial = ""),
        (this.facturaBaja.descripcion = "DE BAJA"),
        (this.facturaBaja.serie = ""),
        (this.facturaBaja.numero = ""),
        (this.facturaBaja.tipoComprobante = "01"),
        (this.itembaja = []);
    },
    borrarCorreo(index){
      this.reciveEmail.splice(index, 1)
      if(this.reciveEmail.length > 0){
        this.mostraremail = false;
      }else{
        this.mostraremail = true;
      }
    },
    enviarEmail: function(data) {
      for (let i = 0; i < this.reciveEmail.length; i++) {
          this.reciveEmail[i] + ","
      }
      let cadena = this.reciveEmail.join(",");
      if(this.recipients !=''){
        this.sendMail(data);  
      }  
      this.previacorreo = true;
      this.sendcorreo = true;
      axios
        .post(process.env.VUE_APP_API_URL + "facturas/mail", {
          token: this.$store.getters.userToken,
          id: data.idFactura,
          mail: cadena
        })
        .then(
          response => (
            (this.previacorreo = false),
            (this.sendcorreo = false),
            this.alertaenvio(response.data.msg)
          )
        )
        .catch(
          error => (
            (this.previacorreo = false),
            (this.sendcorreo = false),
            this.$snotify.error(error.response.data.response, "Error")
          )
        );
    },
    alertaenvio(data){
      if(this.recipients == ''){
        this.$snotify.success(data, "Exito")
      }
    },
    convertirAnticipo(value){
      let tipo = '01';
      axios
      .post(process.env.VUE_APP_API_URL + "anticipos/convertir",{
        token: this.$store.getters.userToken,
        tipoDoc: tipo,
        idDocumento : value.idFactura
      })
      .then(response=>(
        this.$snotify.success("Factura Convertida en Anticipo", "Éxito")
      ))
      .catch(err=>(
       this.$snotify.warning(err.response.data.msg,"Cuidado")
      ))
    },
      send_message(data) {
        if(this.numeroWhatsApp && this.numeroWhatsApp.trim() !== ''){
            if(this.numeroWhatsApp.length == 9){
                const url = 'https://micomprobante.facturaonline.pe/s/pkey-'
                const {
                    idEmisor,
                    serie,
                    numero,
                    idReceptor,
                    importeTotal
                } = data
                let factura = '01';
                const mensaje = 'Comprobante' + ' ' + data.serie +'-'+ data.numero + ' ' + 'Emitido a través de TELEMOVILPERU.COM'
                const cadena = `${idEmisor}|${factura}|${serie}|${numero}|${idReceptor}|${importeTotal}`
                const text = `${url}.${btoa(cadena)}+${mensaje}`
                window.open(`https://wa.me/+51${this.numeroWhatsApp}?text=${text}`, '_blank')
            }else{
                this.$snotify.warning("DEBE INGRESAR 9 DIGITOS")
            }
        }else{
            this.$snotify.warning("DEBE INGRESAR INFORMACION")
        }
      },
      deshabilitarFechasFuturas(date) {
        return date > new Date(); // Bloquea fechas mayores a hoy
      },
      actualizarFecha(fecha) {
        if(fecha == null){
            this.fechaFacturaDelDia = '';
        }else{
            this.fechaFacturaDelDia = this.$moment(fecha).format('YYYY-MM-DD 00:00:00');
            this.listInvoice();
        }
      },
      clearFechas(){
        //LIMPIA LOS FILTROS DE FECHA
        //Y TRAE LOS REGISTRO DEL DIA
        this.fechaFacturaDelDia = '';
        this.f1 ='';
        this.f2 ='';
        this.listInvoice();
      },
      ticketEnvio(value){
        this.ticketenvio = true;
        this.datosTicket = value;
      },
      searchProvinceOrigen: function (ind) {
        let departamentoActual = ''
        if(ind == 1){
            departamentoActual = this.departamentoSeleccionado
            this.provOrigenCargando = true
        }
        axios
        .post(process.env.VUE_APP_API_URL + 'ubigeo/provincia',{
            token: this.$store.getters.userToken,
            department: departamentoActual
        })
        .then(response => (
            this.listProvinceOrigen = response.data,
            this.provOrigenCargando = false                    
        ))
        .catch(error => {})
      },
      searchDistrictOrigen: function (value, ind) {
        let departmentActual = ''
        let provinceActual = ''
        if(ind == 1){
          departmentActual = this.departamentoSeleccionado,
          provinceActual = this.provinciaSeleccionada,
          this.distOrigenCargando = value
        }
        axios
        .post(process.env.VUE_APP_API_URL + 'ubigeo/distrito',{
            token: this.$store.getters.userToken,
            department: departmentActual,
            province: provinceActual
        })
        .then(response => (
            this.listDistrictOrigen = response.data,
            this.distOrigenCargando = false
        ))
        .catch(error => {})
      },
      print: function () {
          this.printweb = true
      },
      printClose: function () {
          this.printweb = false,
          this.ticketenvio = false
      },
      capturarNombreDepartamento(event){
        const codDepartamento = event.target.value;
        const departamento = this.listDepartamento.find(dep => dep.codDepartamento === codDepartamento);
        if (departamento) {
          this.capturaDepartamentoSeleccionado = departamento.nombre; 
        }
      },
      capturarNombreProvincia(event) {
        const codProvincia = event.target.value;
        const provincia = this.listProvinceOrigen.Departments.find(prov => prov.codProvincia === codProvincia);
        if (provincia) {
          this.capturaProvinciaSeleccionada=provincia.nombre; 
        }
      },
      validateInput() {
        if (this.numCelTicket.length > 9) {
          this.numCelTicket = this.numCelTicket.slice(0, 9);
        }
      },
      allowOnlyDeleteAndNumbers(event) {
        // Permitir solo números, borrar (Backspace), y teclas de navegación
        const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete'];
        if (!allowedKeys.includes(event.key) && !/^\d$/.test(event.key)) {
          event.preventDefault();
        }
      }
    }
  }
</script>

<style >
.noticeGuia {
  font-size: 2em;
  color: #006666;
}
.noticeSalir {
  margin-right: 20px;
}
.bordeplus {
  height: 30px;
  width: 30px;
  border-radius: 50px;
}
.tamanioletra {
  font-size: 13px;
  font-family: "Roboto Mono";
  margin-left: 3%;
  padding: 0px;
}
.cursor{
  cursor: pointer;
}
</style>
<style>
@import url("https://fonts.googleapis.com/css?family=Roboto+Mono&display=swap");
</style>